import { ListItem, Typography } from '@mui/material';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import { green, orange, red, yellow } from '@mui/material/colors';
import { COMPLETE_STATUS, FAILED_TO_UPLOAD_STATUS, IN_PROGRESS_STATUS } from './EventStatusConstant';
import { CameraUploadDetails } from '../../../model/event-upload-details';
import { useEffect, useState } from 'react';
import { fetchCameraIdentifier } from '../../../services/CameraService';

interface IProps {
  cameraStatusDetails: CameraUploadDetails;
  groupPicturesExpected: boolean;
}

function CameraUploadStatus({ cameraStatusDetails, groupPicturesExpected }: IProps) {
  const [cameraName, setCameraName] = useState('');

  useEffect(() => {
    const _cameraName = fetchCameraIdentifier(cameraStatusDetails.cameraName, groupPicturesExpected);
    setCameraName(_cameraName);
  }, [cameraStatusDetails?.cameraName, groupPicturesExpected]);
  function getIcon() {
    if (cameraStatusDetails.uploadStatus === COMPLETE_STATUS) {
      return <Brightness1Icon sx={{ color: green[200] }} />;
    }

    if (cameraStatusDetails.uploadStatus === FAILED_TO_UPLOAD_STATUS) {
      return <Brightness1Icon sx={{ color: red[200] }} />;
    }
    if (cameraStatusDetails.uploadedAssetCountMismatch) {
      return <Brightness1Icon sx={{ color: orange[500] }} />;
    } else if (cameraStatusDetails.uploadStatus === IN_PROGRESS_STATUS) {
      return <Brightness1Icon sx={{ color: yellow[200] }} />;
    }
  }

  return (
    <ListItem sx={{ pl: 0 }}>
      <Typography sx={{ float: 'left', mt: 1 }}>{getIcon()}</Typography>
      <Typography sx={{ float: 'left', ml: 1, pl: 0 }}>{cameraName + ':'}</Typography>
      <Typography sx={{ float: 'left', ml: 1, fontWeight: 1000 }}>{cameraStatusDetails.uploadStatus}</Typography>
    </ListItem>
  );
}

export default CameraUploadStatus;
